module.exports = __webpack_public_path__ + "static/media/shape2_7.3492624d.obj";